import { render, staticRenderFns } from "./RankScore.vue?vue&type=template&id=953f2154&scoped=true"
import script from "./RankScore.vue?vue&type=script&lang=js"
export * from "./RankScore.vue?vue&type=script&lang=js"
import style0 from "./RankScore.vue?vue&type=style&index=0&id=953f2154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953f2154",
  null
  
)

export default component.exports